export default __webpack_public_path__ + "static/media/postgresql.6d3129da.svg";